module.exports = __webpack_public_path__ + "img/button-hardware.31669063.svg";